// Vianey Beauty Theme — JavaScript

document.addEventListener('DOMContentLoaded', function () {

  // ── Promo Bar Close ─────────────────────────────────────────────
  const promoClose = document.querySelector('.promo-bar__close');
  const promoBar = document.querySelector('.promo-bar');
  if (promoClose && promoBar) {
    promoClose.addEventListener('click', function () {
      promoBar.style.display = 'none';
    });
  }

  // ── Rotating Promo Bar Messages ─────────────────────────────────
  const promoMessages = [
    '🚚 FREE SHIPPING ON ORDERS $50+ — NO CODE NEEDED!',
    '💕 USE CODE BEAUTY15 FOR 15% OFF YOUR FIRST ORDER',
    '⭐ LOVED BY 10,000+ BEAUTIES — SHOP NOW',
    '🎁 NEW: MYSTERY BEAUTY BOX — ONLY $25',
    '🔥 TIKTOK VIRAL WIGS — IN STOCK NOW'
  ];
  const promoText = document.querySelector('.promo-bar__text');
  if (promoText) {
    let idx = 0;
    setInterval(function () {
      promoText.style.opacity = '0';
      setTimeout(function () {
        idx = (idx + 1) % promoMessages.length;
        promoText.textContent = promoMessages[idx];
        promoText.style.opacity = '1';
      }, 300);
    }, 3500);
    promoText.style.transition = 'opacity 0.3s ease';
  }

  // ── Countdown Timer ─────────────────────────────────────────────
  function updateCountdown() {
    const end = new Date();
    end.setHours(23, 59, 59, 999);
    const now = new Date();
    const diff = end - now;
    if (diff <= 0) return;

    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);

    const setVal = function (id, val) {
      const el = document.getElementById(id);
      if (el) el.textContent = String(val).padStart(2, '0');
    };
    setVal('countdown-h', h);
    setVal('countdown-m', m);
    setVal('countdown-s', s);
  }
  updateCountdown();
  setInterval(updateCountdown, 1000);

  // ── Product Tabs ────────────────────────────────────────────────
  const tabBtns = document.querySelectorAll('.tab-btn');
  const productSections = document.querySelectorAll('.products-tab-content');

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const target = btn.dataset.tab;
      tabBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      productSections.forEach(function (sec) {
        sec.style.display = sec.dataset.tab === target ? 'grid' : 'none';
      });
    });
  });

  // ── Promo Code Copy ─────────────────────────────────────────────
  const promoCodeBtns = document.querySelectorAll('.promo-code-btn, .copy-code-btn');
  promoCodeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const code = btn.dataset.code || 'BEAUTY15';
      navigator.clipboard.writeText(code).catch(function () {
        const el = document.createElement('textarea');
        el.value = code;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      });
      const original = btn.innerHTML;
      btn.innerHTML = btn.innerHTML.replace(code, '✓ ¡Copiado!');
      setTimeout(function () { btn.innerHTML = original; }, 2000);

      const msg = document.querySelector('.promo-code-copied');
      if (msg) {
        msg.classList.add('show');
        setTimeout(function () { msg.classList.remove('show'); }, 2000);
      }
    });
  });

  // ── Email Popup ─────────────────────────────────────────────────
  const popup = document.querySelector('.email-popup-overlay');
  const popupClose = document.querySelector('.email-popup__close');
  const popupForm = document.querySelector('.email-popup__form');

  if (popup) {
    const shown = sessionStorage.getItem('vb_popup_shown');
    if (!shown) {
      setTimeout(function () {
        popup.classList.add('show');
        sessionStorage.setItem('vb_popup_shown', '1');
      }, 5000);
    }
  }
  if (popupClose && popup) {
    popupClose.addEventListener('click', function () {
      popup.classList.remove('show');
    });
    popup.addEventListener('click', function (e) {
      if (e.target === popup) popup.classList.remove('show');
    });
  }
  if (popupForm) {
    popupForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const emailInput = popupForm.querySelector('input[type="email"]');
      if (emailInput && emailInput.value) {
        const body = popupForm.querySelector('.email-popup__body');
        if (body) {
          body.innerHTML = '<div style="text-align:center;padding:2rem"><p style="font-size:2.5rem">🎉</p><h3 style="font-family:var(--font-serif);font-size:1.5rem;margin:.75rem 0">¡Tu código está en camino!</h3><p style="color:var(--muted)">Revisa tu email y usa <strong style="color:var(--primary)">BEAUTY15</strong> en tu próxima compra.</p></div>';
        }
        setTimeout(function () {
          popup.classList.remove('show');
        }, 3000);
      }
    });
  }

  // ── Marquee Duplicate ────────────────────────────────────────────
  const track = document.querySelector('.marquee-track');
  if (track) {
    track.innerHTML += track.innerHTML;
  }

  // ── Smooth scroll for anchor links ──────────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      const id = a.getAttribute('href').slice(1);
      const el = document.getElementById(id);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
